import React, { useState, useContext } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocation } from "@fortawesome/free-solid-svg-icons";

import { useEffect } from "react";
import { useBot } from "../../../hooks/test/useBot";

import { AuthContext } from "../../../context/authContext/authContext";

import { SocketContext } from "../../../context/SocketContext";
import { formatDate } from "../../../helpers/formatDate";
import { Spinner } from "../../Spinner";

export const SidebarNotifica = () => {
  const [notificaciones, setNotificaciones] = useState([]);
  const { socket } = useContext(SocketContext);
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const { getNotificacionesBot } = useBot();

  useEffect(() => {
    if(!socket) return;
    socket.on("Evento_del_bot_para_teleapp", () => {
      loadNotificaciones();
    });
    return () => {
      socket.off("Evento_del_bot_para_teleapp");
    };
  }, [socket]);

  useEffect(() => {
    if (user.negocio_id) loadNotificaciones();
  }, []);

  const loadNotificaciones = async () => {
    setLoading(true);
    let resp = await getNotificacionesBot(user.negocio_id);
    if (!resp.ok) return;
    setNotificaciones([...resp.notificacion]);
    setLoading(false);
  };

  return (
    <>
      {loading && <Spinner />}
      <div>
        {notificaciones.length > 0 ? (
          notificaciones.map((notificacion, index) => {
            return (
              <div key={index}>
                <div className="float-e-margins">
                  <div className="ibox-content">
                    <div className="p-l-10">
                      <div className="d-flex w-100 align-items-center justify-content-between">
                        <strong className="mb-1">Chat Bot</strong>
                        <small className="text-muted">
                          Accion:{" "}
                          <b className="text-lowercase">
                            {notificacion.accion}
                          </b>
                        </small>
                      </div>
                      <div className="col-10 mb-1 small">
                        <b>{notificacion.tripulante}</b>. Con la unidad{" "}
                        <b>{notificacion.unidad}</b>, solicito{" "}
                        <b className="text-lowercase"> {notificacion.accion}</b>{" "}
                        <>
                          {" "}
                          el dia{" "}
                          <b>
                            {formatDate(notificacion.fecha_hora_peticion)}
                          </b>{" "}
                          horas.
                          {/* a las{" "}
                          <b>
                            {notificacion.fecha_hora_peticion.substring(11, 16)}{" "}
                          </b>
                          horas */}
                        </>
                        <br></br>
                        <b>Estatus:</b>{" "}
                        {notificacion.denegado &&
                        !notificacion.fecha_hora_autorizacion ? (
                          <>
                            <b className="text-info">Solicitud denegada. </b>
                            {notificacion.speed > 0
                              ? `Unidad en movimiento (${notificacion.speed} k/h.)`
                              : !notificacion.unidad_encontrada
                              ? "Unidad no encontrada en bitacora."
                              : notificacion.id_validacion == 1
                              ? "Operador no registrado"
                              : notificacion.id_validacion == 2
                              ? "Unidad sin viaje"
                              : notificacion.id_validacion == 3
                              ? "Numero sin coincidencia con la ruta"
                              : notificacion.id_validacion == 4
                              ? "Unidad no encontrada en bitacora"
                              : notificacion.id_validacion == 5
                              ? "Unidad fuera de geocerca"
                              : notificacion.id_validacion == 6
                              ? "Unidad en movimiento"
                              : notificacion.id_validacion == 8
                              ? "Bot no pudo comunicarse"
                              : notificacion.id_validacion == 10
                              ? "Error al validar número de teléfono"
                              : notificacion.id_validacion == 11
                              ? "GPS con problemas de reporte"
                              : notificacion.id_validacion == 12
                              ? "Operador no confirmo la apertura"
                              : notificacion.id_validacion == 13
                              ? "Nombre sin coincidencia en registros"
                              : notificacion.id_validacion == 14
                              ? "Sin éxito de apertura, excediendo el límite de intentos permitidos"
                              : notificacion.id_validacion == 15
                              ? "Error al obtener código de chapas"
                              : notificacion.id_validacion == 16
                              ? "Error al ejecutar la apertura"
                              : notificacion.id_validacion == 17
                              ? "Sin éxito de apertura"
                              : notificacion.id_validacion == 19
                              ? "Unidad no asignada al operador"
                              : "Error al ejecutar la apertura"}
                          </>
                        ) : notificacion.finalizado &&
                          notificacion.ejecutado &&
                          notificacion.fecha_hora_autorizacion ? (
                          <b className="text-success">Solicitud completada</b>
                        ) : !notificacion.ejecutado ? (
                          <b className="text-danger">No se realizo la accion</b>
                        ) : (
                          <>
                            <b className="text-warning">
                              En espera de operador
                            </b>
                          </>
                        )}
                        <div className="row">
                          {
                            notificacion.latitud && notificacion.longitud ?
                            (
                              <>
                                <div className="col-5">
                                  <button
                                    type="button"
                                    title="ver ubicación de la unidad en google maps"
                                    onClick={() =>
                                      window.open(
                                        `https://www.google.es/maps?q=${notificacion.latitud},${notificacion.longitud}`
                                      )
                                    }
                                    className="btn btn-primary p-2 m-2"
                                  >
                                    <span>
                                      <FontAwesomeIcon icon={faMapLocation} />
                                    </span>
                                    &nbsp; &nbsp;Ver
                                  </button>
                                </div>
                              </>
                            ): ""
                          }

                          <div className="col-7 p-2">
                            {!notificacion.denegado && (
                              <>
                                Cedis:{" "}
                                <b className="text-lowercase">
                                  {notificacion.cedis}
                                </b>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="p-2 m-1">Sin notificaciones</div>
        )}
        {/* {notificaciones.length > 0 && (
          <footer className="mt-auto text-dark-50">
            <div className="row">
              <div className="col-4">Total: {notificaciones.length}</div>
              <div className="col-4">Completadas: </div>
              <div className="col-4">Denegadas: </div>
            </div>
          </footer>
        )} */}
      </div>
    </>
  );
};
